const List = () => import(/* webpackChunkName: "diagnostics" */ "./view/List.vue");

export default [{
  path: "/development/diagnostics",
  name: "development-diagnostics",
  component: List,
}];
